export default "__VITE_ASSET__92850b13__"